import React, { useContext, useEffect } from "react";
import { apiUrl } from "../../../Constants/Constants";
import { AuthContext } from "../../../Constants/AuthProvider";
import { useFetchWithToken } from "./../../FetchWithToken/FetchWithToken";
import { ConfirmationModalContext } from "../../../fautures/ConfirmationModalProvider";
import { toast } from "react-toastify";
import styles from "./ChildLock.module.css";
import BlueBtn from "../../BlueBtn/BlueBtn.module";
const ChildLock = ({ getInfo, item, loadingShower }) => {
  const modalContext = useContext(ConfirmationModalContext);
  const { fetchWithToken, loading } = useFetchWithToken();
  const {
    openUpModal,
    description,
    confirmTitle,
    payloadConfirm,
    toDo,
    closeModal,
  } = modalContext;
  const { onLogout } = React.useContext(AuthContext);
  useEffect(() => {
    loadingShower(loading);
  }, [loading]);

  const activeParentalLock = () => {
    confirmTitle(
      !item.parentalLock
        ? "فعالسازی اینترنت کودکان؟"
        : "غیر فعالسازی اینترنت کودکان؟"
    );
    openUpModal();

    description(
      !item.parentalLock ? (
        <>
          با فعالسازی این سرویس دسترسی این اکانت به کلیه دیتای پورنو و غیر
          اخلاقی مسدود میگردد. شما در هر زمان میتوانید مجدد این حالت را غیر فعال
          نمایید.
        </>
      ) : (
        <>با غیرفعالسازی این سرویس، ترافیک این اکانت به حالت عادی باز میگردد.</>
      )
    );

    toDo(() => switchParentalLock);
    payloadConfirm("");
  };

  const switchParentalLock = () => {
    const former = new FormData();
    former.append("accountid", item.id);

    fetchWithToken(
      apiUrl + "user/parental-lock",
      { method: "POST" },
      former
    ).then((data) => {
      closeModal();
      if (data.status === "200") {
        toast.success(data.data);

        getInfo();
      } else if (data.status === "6") {
        toast.error(data.data);
      }
      if (data.status === "401") {
        onLogout();
      }
    });
  };

  return (
    <div className={styles.userActions}>
      {/* <div className={styles.detailitem}> */}
      <div className={`${styles.label} ${styles.fuller} `}>
        <div className={styles.mkcol2}>
          <div>
            <i class="fa-solid fa-family"></i>
            اینترنت کودکان
          </div>

          {!item.parentalLock ? (
            <div className={styles.statusSecure}>
              <i class="fa-solid fa-lock-open"></i>
              غیرفعال
            </div>
          ) : (
            <>
              <div className={`${styles.statusSecure} ${styles.greenOnShow}`}>
                <i class="fa-solid fa-lock"></i>
                فعال
              </div>
            </>
          )}
        </div>
        {/* <div className={styles.downpartdesc}>
          <div className={styles.trafficde}>
            <i class="fal fa-exclamation-circle"></i>
            <div className={styles.aftertrcde}>
              با فعال‌سازی این گزینه، دسترسی به وب‌سایت‌های پورنوگرافی و محتوای
              غیراخلاقی برای این اکانت مسدود می‌شود. (همراه با فعالسازی حالت
              safe search برروی گوگل)
            </div>
          </div>
        </div> */}
      </div>
      <div className={styles.btnBox}>
        <BlueBtn
          bgColor="#7AB800"
          bgHover="#a0ef03"
          onAtion={() => activeParentalLock()}
        >
          {!item.parentalLock
            ? "فعالسازی اینترنت کودکان"
            : "غیر فعالسازی اینترنت کودکان"}
        </BlueBtn>
      </div>
    </div>
  );
};

export default ChildLock;
